<app-card [cardOptionBtnValue]="'admin.product.show.edit_product'|translate" [cardOptionBtn]="true"
          [cardRouterLink]="'/back-office/product/' + product.id"
          [title]="'admin.product.show.product_information'|translate">
  <div class="row">
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.product.name'|translate}}</p>
      <label class="m-b-15">{{product.name}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.product.number'|translate}}</p>
      <label class="m-b-15">{{product.number}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.product.dealer_price'|translate}}</p>
      <label class="m-b-15">{{product.dealerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.product.customer_price'|translate}}</p>
      <label class="m-b-15">{{product.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</label>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.product.type'|translate}}</p>
      <label class="m-b-15">{{product.number}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.model.model'|translate}}</p>
      <label class="m-b-15">
        <span class="list-Model" *ngFor="let model of productModels ">
         {{model.name}}
        </span>
      </label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.product.status'|translate}}</p>
      <label
        class="m-b-15">{{((product.status) ? getProduct().PRODUCT_ACTIVE : getProduct().PRODUCT_INACTIVE)|translate}}</label>
    </div>
  </div>

</app-card>

<app-card
  [title]="'admin.option.show.options'|translate">

  <nav ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs">
    <!-- start tab prices-->
    <div [ngbNavItem]="1" id="tab-prices">
      <a ngbNavLink class="nav-link">{{'admin.option.show.options.tab.prices'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>{{'doctrine.product.country'|translate}}</th>
              <th>{{'doctrine.product.dealer_price'|translate}}</th>
              <th>{{'doctrine.country.dealer_vat'|translate}}</th>
              <th>{{'doctrine.product.customer_price'|translate}}</th>
              <th>{{'doctrine.country.customer_vat'|translate}}</th>
              <th>% {{'doctrine.product.discount'|translate}}</th>
              <th class="text-end">{{'global.actions'|translate}}</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let item of prices;let i = index">
              <tr>
                <td>{{item.country.name}}</td>
                <td>{{item.dealerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                <td>{{item.country.dealerVat}}%</td>
                <td>{{item.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
                <td>{{item.country.customerVat}}%</td>
                <td>{{item.discount ? item.discount : '-'}}</td>
                <td class="text-end">
                  <!--actions-->
                  <span class="action-button">
                    <a class="ripple light ms-2" (click)="addPrice(item)">
                    <i class="fa fa-pencil fa-lg"></i>
                  </a>
                  </span>
                <td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
      </ng-template>
    </div>
    <!--end tab prices-->

    <!--start tab stock-->
    <div [ngbNavItem]="2" id="tab-stock">
      <a ngbNavLink class="nav-link">{{'doctrine.product.tab.stock'|translate}}</a>
      <ng-template ngbNavContent>
        <form novalidate #manageStockForm="ngForm">
          <div class="form-row row">
            <div class="form-group mt-3 ms-2">
              <label for="manage-stock">
                <input type="checkbox" name="manageStockItem" id="manage-stock" #manageStockItem="ngModel"
                       [(ngModel)]="stock.manageStock" (ngModelChange)="sendFormOnUncheckStock($event)">
                {{'doctrine.product.stock.stock_title'| translate}}
              </label>
            </div>
          </div>
          <div class="form-row row" *ngIf="stock.manageStock">
            <div class="form-group col-md-3">
              <label class="float-label">{{'doctrine.product.stock.ean_sku_code'|translate}} <span class="star">*</span></label>
              <input type="text" name="eanItem" #eanItem="ngModel" [(ngModel)]="stock.EANCode"
                     class="form-control" required>
            </div>
            <div class="form-group col-md-3">
              <label class="float-label">{{'doctrine.product.stock.stock'|translate}}</label>
              <input type="text" name="stockItem" #stockItem="ngModel" [(ngModel)]="stock.stock" pattern="[0-9]+"
                     class="form-control" disabled>
              <div class="messages text-danger"
                   *ngIf="stockItem.invalid && stockItem.dirty && stockItem.errors?.required">
                {{'errors.required'|translate}}
              </div>
              <div class="messages text-danger"
                   *ngIf="stockItem.invalid && stockItem.dirty && stockItem.errors?.pattern">
                {{'errors.invalid'|translate}}
              </div>
            </div>
            <div class="form-group col-md-3">
              <label class="float-label">{{'doctrine.product.stock.low_stock_trigger'|translate}}<span
                class="star"> *</span></label>
              <input type="text" name="lowStockItem" #lowStockItem="ngModel" [(ngModel)]="stock.lowStockTrigger"
                     pattern="[0-9]+"
                     class="form-control" required>
              <div class="messages text-danger"
                   *ngIf="lowStockItem.invalid && lowStockItem.dirty && lowStockItem.errors?.required">
                {{'errors.required'|translate}}
              </div>
              <div class="messages text-danger"
                   *ngIf="lowStockItem.invalid && lowStockItem.dirty && lowStockItem.errors?.pattern">
                {{'errors.invalid'|translate}}
              </div>
            </div>
            <div class="form-group col-md-12">
            <!-- Start Multi-Collies -->
            <app-collies-form *ngIf="stock.manageStock && productCollies"
                              [productCollies]="productCollies"
                              [productId]="productId">
            </app-collies-form>
            <!-- End Multi-Collies -->
            </div>
          </div>
        </form>
        <div class="pull-right my-3" *ngIf="stock.manageStock">
          <button (click)="ManageStock(false)" class="btn btn-link me-4"
                  type="button">{{'global.cancel'|translate}}</button>
          <button type="button" class="btn btn-primary ripple light" (click)="ManageStock(true)"
                  [disabled]="manageStockForm.invalid">{{'global.save_changes'|translate}}</button>
        </div>

      </ng-template>
    </div>
    <!--end tab stock-->

    <!--start tab property-->
    <div [ngbNavItem]="3" id="tab-property">
      <a ngbNavLink class="nav-link">{{'doctrine.product.tab.properties'|translate}}</a>
      <ng-template ngbNavContent>
        <form #propertyForm="ngForm">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>{{'doctrine.product.properties.name'|translate}}</th>
                <th>{{'doctrine.product.properties.description'|translate}}</th>
                <th>{{'doctrine.product.properties.type'|translate}}</th>
                <th>{{'doctrine.product.properties.amount'|translate}}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="table-active">
                <th colspan="4" class="text-center">{{'admin.product_property.general'|translate }}</th>
              </tr>
              <ng-container *ngFor="let productProperty of this.productProperties">
                <tr>
                  <td>{{productProperty.name}}</td>
                  <td>{{productProperty.description}}</td>
                  <td>
                    {{(productProperty.status) ? getProperty().PROPERTY_AMOUNT : getProperty().PROPERTY_METERS}}
                  </td>
                  <td (click)="productProperty.check = true; isEditProperty = true;" [ngStyle]="{'width.rem': '8'}">
                    <span class="form-group col-md-6" *ngIf="!productProperty.check"> {{productProperty.amount}}</span>
                    <ng-container *ngIf="productProperty.check == true">
                      <div class="form-group m-0 p-0" *ngIf="productProperty.check && isEditProperty">
                        <input type="text"
                               name="productPropertyItem-{{productProperty.id}}"
                               #productPropertyItem="ngModel"
                               [(ngModel)]="productProperty.amount"
                               pattern="\d+([.]\d(\d)?)?"
                               min="0"
                               class="form-control" required>
                        <div class="messages text-danger"
                             *ngIf="productPropertyItem.invalid && productPropertyItem.dirty && productPropertyItem.errors?.required">
                          {{'errors.required'|translate}}
                        </div>
                        <div class="messages text-danger"
                             *ngIf="productPropertyItem.invalid && productPropertyItem.dirty && productPropertyItem.errors?.min">
                          {{'errors.invalid'|translate}}
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngFor="let model of this.productModels">
                <ng-container *ngFor="let style of productPropertiesStyles;let j=index">
                  <tr *ngIf="style.properties.length > 0" class="table-active">
                    <th colspan="4" class="text-center ">{{model.name}} {{'(' + style.name + ')'}}</th>
                  </tr>
                  <tr *ngFor="let property of style.properties;let i=index;">
                    <td>
                      {{property.name}}
                    </td>
                    <td>
                      {{property.description}}
                    </td>
                    <td>
                      {{(property.status) ? getProperty().PROPERTY_AMOUNT : getProperty().PROPERTY_METERS}}
                    </td>
                    <td (click)="property.check = true; isEditProperty = true;" [ngStyle]="{'width.rem': '8'}">
                      <span class="form-group col-md-6" *ngIf="!property.check"> {{property.amount}}</span>
                      <ng-container *ngIf="property.check == true">
                        <div class="form-group m-0 p-o" *ngIf="property.check && isEditProperty">
                          <input type="text" [name]="'productPropertyItem'+j+'-'+i" #productPropertyItem="ngModel"
                                 [(ngModel)]="property.amount" pattern="\d+([.]\d(\d)?)?"
                                 class="form-control" required>
                          <div class="messages text-danger"
                               *ngIf="productPropertyItem.invalid && productPropertyItem.dirty && productPropertyItem.errors?.required">
                            {{'errors.required'|translate}}
                          </div>
                          <div class="messages text-danger"
                               *ngIf="productPropertyItem.invalid && productPropertyItem.dirty && productPropertyItem.errors?.pattern">
                            {{'errors.invalid'|translate}}
                          </div>
                        </div>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              </tbody>
            </table>
            <button type="button" class="btn btn-simple ripple me-2 btn-primary light"
                    *ngIf="isEditProperty || isEditStyleProperty" [disabled]="!propertyForm.valid"
                    (click)="ManageProductPropertyAmount(true)">{{'admin.product.add.property_button'|translate}}
            </button>
          </div>
        </form>
      </ng-template>
    </div>
    <!--end tab property-->

    <!--start tab product-->
    <div [ngbNavItem]="4" id="tab-product">
      <a ngbNavLink class="nav-link">{{'doctrine.product.tab.composed_product'|translate}}</a>
      <ng-template ngbNavContent>
        <form novalidate #manageStockForm="ngForm">
          <div class="form-row row">
            <div class="form-group  mt-3 ms-3">
              <label>
                <input type="checkbox" name="manageStockItem" #manageStockItem="ngModel"
                       [(ngModel)]="product.hasProduct"> {{'admin.contain_product'|translate}}
              </label>
            </div>
          </div>
        </form>
      </ng-template>
    </div>
    <!--end tab product-->
    
    <!--start tab parts-->
    <div [ngbNavItem]="5" id="tab-part">
      <a ngbNavLink class="nav-link">{{'doctrine.product.tab.parts'|translate}}</a>
      <ng-template ngbNavContent>
        <form novalidate #managePartForm="ngForm">
          <div class="form-row row">
            <div class="form-group  mt-3 ms-3">
              <label>
                <input type="checkbox" name="managePartItem" #managePartItem="ngModel" (change)="onHasPartProductChange($event)"
                       [(ngModel)]="productHasPart"> {{'admin.this_product_has_parts'|translate}}
              </label>
            </div>
          </div>
        </form>
        
        <ng-container *ngIf="productHasPart">
          <app-parts-table 
            [parts]="product.partProducts"
            [isUpdating]="isUpdatingPartAmount"
            [showTable]="productHasPart && product.partProducts?.length > 0"
            [multipliers]="multipliers"
            (updateAmount)="updatePartAmount($event)"
            (removePart)="removePart($event)"
            (updateMultiplier)="updatePartMultiplier($event)">
          </app-parts-table>
        </ng-container>

        <div class="px-3 mb-4 pull-left" *ngIf="productHasPart">
          <button class="btn btn-primary ripple light" (click)="showPartGrid()">
            <span class="feather icon-plus"></span><span>{{'admin.product.show.add.part'|translate}}</span>
          </button>
        </div>
      </ng-template>
    </div>
    <!--end tab parts-->

    <!--start tab sizes-->
    <div [ngbNavItem]="6" id="tab-sizes" *ngIf="isRug()">
      <a ngbNavLink class="nav-link">{{'doctrine.product.tab.sizes'|translate}}</a>
      <ng-template ngbNavContent>
        <!--The whole feature, explained to the person who has to use it. Do not drop it.-->
        <p class="px-3 pt-3 text-muted">{{'doctrine.product.fixed_price_hint'|translate}}</p>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>{{'doctrine.product.width_cm'|translate}}</th>
              <th>{{'doctrine.product.length_cm'|translate}}</th>
              <!--The VAT treatment is on screen on purpose: a back-office user must never
                  have to guess which figure includes VAT. That ambiguity is worth 21%.-->
              <th>{{'doctrine.product.fixed_dealer_price'|translate}}</th>
              <th>{{'doctrine.product.fixed_customer_price'|translate}}</th>
              <th>{{'doctrine.product.position'|translate}}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let size of productSizes; let i = index; trackBy: trackByIndex">
              <td>
                <input type="number" [min]="product.minWidthCm || 1" [max]="product.maxWidthCm" class="form-control"
                       [(ngModel)]="size.widthCm" [ngModelOptions]="{standalone: true}">
                <div class="messages text-danger" *ngIf="sizeWidthOutOfRange(size)">
                  {{sizeRangeKey('width')|translate:{min: product.minWidthCm, max: product.maxWidthCm} }}
                </div>
              </td>
              <td>
                <input type="number" [min]="product.minLengthCm || 1" [max]="product.maxLengthCm" class="form-control"
                       [(ngModel)]="size.lengthCm" [ngModelOptions]="{standalone: true}">
                <div class="messages text-danger" *ngIf="sizeLengthOutOfRange(size)">
                  {{sizeRangeKey('length')|translate:{min: product.minLengthCm, max: product.maxLengthCm} }}
                </div>
              </td>
              <td>
                <input type="number" min="0" step="0.01" class="form-control"
                       [(ngModel)]="size.fixedDealerPrice" [ngModelOptions]="{standalone: true}">
              </td>
              <td>
                <input type="number" min="0" step="0.01" class="form-control"
                       [(ngModel)]="size.fixedCustomerPrice" [ngModelOptions]="{standalone: true}">
                <div class="messages text-danger" *ngIf="sizeFixedPriceIncomplete(size)">
                  {{'validators.validators.product_size.fixed_price.incomplete'|translate}}
                </div>
                <div class="messages text-danger" *ngIf="sizeFixedPriceNotPositive(size)">
                  {{'doctrine.product.fixed_price_positive'|translate}}
                </div>
              </td>
              <td>{{i + 1}}</td>
              <td>
                <a class="me-2" [class.text-muted]="i === 0" (click)="moveSize(i, -1)"><i class="feather icon-arrow-up"></i></a>
                <a class="me-2" [class.text-muted]="i === productSizes.length - 1" (click)="moveSize(i, 1)"><i class="feather icon-arrow-down"></i></a>
                <a class="text-danger" (click)="removeSize(i)"><i class="feather icon-trash-2"></i></a>
              </td>
            </tr>
            <tr *ngIf="productSizes.length === 0">
              <td colspan="6" class="text-muted">{{'doctrine.product.no_sizes'|translate}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="px-3 mb-4">
          <button class="btn btn-primary ripple light me-2" (click)="addSize()">
            <span class="feather icon-plus"></span><span>{{'admin.product.show.add.size'|translate}}</span>
          </button>
          <button class="btn btn-primary ripple light" (click)="saveSizes()"
                  [disabled]="!sizesAreValid() || isSavingSizes">
            {{'global.save_changes'|translate}}
          </button>
        </div>
      </ng-template>
    </div>
    <!--end tab sizes-->
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</app-card>

<form *ngIf="activeTab===4" class="" #setForm="ngForm" action="javascript:">
  <div class="row">
    <div class="col-sm-12">

      <ng-container *ngIf="product.hasProduct">
        <ng-container *ngFor="let packageItem of product.packages;let i=index">
          <div class="card" *ngIf="packageItem.deleted !== true">
            <div class="card-header">
              <h5> {{'admin.product.set'|translate}}</h5>
              <button *ngIf="showDeleteBtn(product.packages)" (click)="deleteModalShow(i,packageItem)"
                      class="btn btn-primary delete-set-btn mt-1"
                      type="button">{{'admin.product.show.remove.set'|translate}}</button>
            </div>
            <div class="card-block">
              <h4 class="sub-title">{{'admin.product.set.name'|translate}}</h4>
              <div class="form-group row">
                <ng-container *ngFor="let field of packageItem.translationKeys">
                  <ng-container *ngFor="let t of packageItem.translationEntries[field]; let j=index">
                    <div class="col-sm-4">
                      <label class="float-label">{{'doctrine.package.name'|translate}} ({{ this.languageMap[t[0]]}})
                        <span>*</span> </label>
                      <input type="text" [name]="'nameItem'+i+j" #nameItem="ngModel"
                             [(ngModel)]="packageItem.translations[field][t[0]]"
                             class="form-control" required>

                      <div class="messages text-danger"
                           *ngIf="nameItem.invalid && nameItem.dirty && nameItem.errors?.required">
                        {{'errors.required'|translate}}
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
              <h4 class="sub-title">{{'admin.option.show.options.tab.options'|translate}}</h4>
              <div class="form-group row">
                <div class="col-sm-4">
                  <label class="float-label">{{'doctrine.package.input_type'|translate}} <span
                    class="star">*</span></label>
                  <ng-select [name]="'inputTypeItem'+i" #inputTypeItem="ngModel" [(ngModel)]="packageItem.inputType"
                             required [clearable]="false">
                    <ng-option [value]="select" *ngFor="let select of selects">{{select}}</ng-option>
                  </ng-select>
                </div>
                <div class="col-sm-4 border-checkbox-section d-flex align-items-center pt-4">
                  <div class="border-checkbox-group border-checkbox-group-primary">
                    <input type="checkbox" [id]="'requiredItem'+i" class="border-checkbox" [name]="'requiredItem'+i"
                           #requiredItem="ngModel"
                           [(ngModel)]="packageItem.required">
                    <label class="border-checkbox-label mb-0"
                           [for]="'requiredItem'+i">{{'errors.required'|translate}}</label>
                  </div>
                </div>
              </div>

              <h4 class="sub-title">{{'doctrine.product.title'|translate}}</h4>
              <div class="table-responsive" style="padding-bottom: 150px">
                <table class="table table-inverse">
                  <thead>
                  <tr>
                    <th>{{'doctrine.product.name'|translate}}</th>
                    <th>{{'doctrine.product.number'|translate}}</th>
                    <th>{{'doctrine.product.options'|translate}}</th>
                    <th>{{'doctrine.product.dealer_price'|translate}}</th>
                    <th>{{'doctrine.product.customer_price'|translate}}</th>
                    <th>{{'doctrine.product.amount'|translate}}</th>
                    <th>{{'doctrine.product.status'|translate}}</th>
                    <th>{{'doctrine.product.position'|translate}}</th>
                    <th>{{'global.actions'|translate}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-container *ngFor="let item of packageItem.packageProducts;let z=index">
                    <tr *ngIf="item.deleted !== true && item.product.deleted !== true">
                      <td>{{item.product.name}}</td>
                      <td>{{item.product.number}}</td>
                      <td>
                        <ng-select [items]="this.productOptions[item.id]" [(ngModel)]="item.selectedOptionProducts" [ngModelOptions]="{standalone: true}" [multiple]="true" (change)="changeOption($event, item )" [clearable]="true"></ng-select>
                      </td>
                      <td (click)="item.product.checkDealerPrice = true; isEditProduct = true;"
                          [ngStyle]="{'width.rem': '10'}">
                    <span
                      *ngIf="!item.product.checkDealerPrice">{{item.dealerPrice | BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</span>
                        <ng-container *ngIf="item.product.checkDealerPrice == true">
                          <div class="form-group m-0 p-0" *ngIf="item.product.checkDealerPrice">
                            <input type="number"
                                   [name]="'checkDealerPrice'+z"
                                   #checkDealerPrice="ngModel"
                                   [(ngModel)]="item.dealerPrice"
                                   min="0"
                                   class="form-control" required>
                            <div class="messages text-danger"
                                 *ngIf="checkDealerPrice.invalid && checkDealerPrice.dirty && checkDealerPrice.errors?.required">
                              {{'errors.required'|translate}}
                            </div>
                            <div class="messages text-danger"
                                 *ngIf="checkDealerPrice.invalid && checkDealerPrice.dirty && checkDealerPrice.errors?.min">
                              {{'errors.invalid'|translate}}
                            </div>
                          </div>
                        </ng-container>
                      </td>
                      <td (click)="item.product.checkCustomerPrice = true; isEditProduct = true;"
                          [ngStyle]="{'width.rem': '10'}">
                    <span
                      *ngIf="!item.product.checkCustomerPrice">{{item.customerPrice | BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</span>
                        <ng-container *ngIf="item.product.checkCustomerPrice == true">
                          <div class="form-group m-0 p-0" *ngIf="item.product.checkCustomerPrice">
                            <input type="number"
                                   [name]="'checkCustomerPrice'+z"
                                   #checkCustomerPrice="ngModel"
                                   [(ngModel)]="item.customerPrice"
                                   min="0"
                                   class="form-control" required>
                            <div class="messages text-danger"
                                 *ngIf="checkCustomerPrice.invalid && checkCustomerPrice.dirty && checkCustomerPrice.errors?.required">
                              {{'errors.required'|translate}}
                            </div>
                            <div class="messages text-danger"
                                 *ngIf="checkCustomerPrice.invalid && checkCustomerPrice.dirty && checkCustomerPrice.errors?.min">
                              {{'errors.invalid'|translate}}
                            </div>
                          </div>
                        </ng-container>
                      </td>

                      <td (click)="item.product.checkAmount = true;" [ngStyle]="{'width.rem': '8'}">
                        <span *ngIf="!item.product.checkAmount">{{item.amount}}</span>
                        <ng-container *ngIf="item.product.checkAmount == true">
                          <div class="form-group m-0 p-0" *ngIf="item.product.checkAmount">
                            <input type="number"
                                   [name]="'productAmount'+z"
                                   #productAmount="ngModel"
                                   [(ngModel)]="item.amount"
                                   min="0"
                                   class="form-control" required>
                            <div class="messages text-danger"
                                 *ngIf="productAmount.invalid && productAmount.dirty && productAmount.errors?.required">
                              {{'errors.required'|translate}}
                            </div>
                            <div class="messages text-danger"
                                 *ngIf="productAmount.invalid && productAmount.dirty && productAmount.errors?.min">
                              {{'errors.invalid'|translate}}
                            </div>
                          </div>
                        </ng-container>
                      </td>

                      <td>
                        <span *ngIf="item.product.status, else falseShow">{{'global.active'|translate}}</span>
                        <ng-template #falseShow>
                          <span>{{'global.inactive'|translate}}</span>
                        </ng-template>
                      </td>

                      <td (click)="item.product.check = true;" [ngStyle]="{'width.rem': '8'}">
                        <span *ngIf="!item.product.check">{{item.position}}</span>
                        <ng-container *ngIf="item.product.check == true">
                          <div class="form-group p-0 m-0" *ngIf="item.product.check">
                            <input type="number"
                                   [name]="'productPosition'+z"
                                   #productPosition="ngModel"
                                   [(ngModel)]="item.position"
                                   min="1"
                                   class="form-control" required>
                            <div class="messages text-danger"
                                 *ngIf="productPosition.invalid && productPosition.dirty && productPosition.errors?.required">
                              {{'errors.required'|translate}}
                            </div>
                            <div class="messages text-danger"
                                 *ngIf="productPosition.invalid && productPosition.dirty && productPosition.errors?.min">
                              {{'errors.invalid'|translate}}
                            </div>
                          </div>
                        </ng-container>
                      </td>

                      <td>
                        <!--remove product-->
                        <button type="button" class="btn btn-lg btn-primary btn-icon ripple light ms-1 btn-action"
                                (click)="removeProduct(i,z)"><i
                          class="fa fa-close"></i></button>
                      </td>

                    </tr>
                  </ng-container>
                  </tbody>
                </table>
              </div>
              <div class="card-block pull-right">
                <!---add product to product-->
                <button class="btn btn-primary ripple light" (click)="showProductGrid(i)">
                  <span class="feather icon-plus"></span><span>{{'admin.product.show.add.product'|translate}}</span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <!--add new set-->


      <div class="card-block pull-left">
        <button type="button" class="btn btn-primary ripple light" (click)="newPackage()"
                *ngIf="product.hasProduct">{{'admin.product.show.add.set'|translate}}</button>
      </div>


      <!--save-->
      <div class="card-block pull-right">
        <button (click)="redirectToList()" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
        <button type="button" class="btn btn-primary ripple light"
                [disabled]="DisableSaveBtn(!setForm.valid)"
                (click)="managePackage()">{{'global.save_changes'|translate}}</button>
      </div>
    </div>
  </div>
</form>

<!-- ADD PRICE TO PRODUCT -->
<app-modal-basic #addPriceModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{(isEdit ? 'global.soft_edit_title' : 'global.soft_add_title') | translate:{entity: 'Price'} }}
    </h4>
    <button type="button" class="close basic-close" (click)="addPriceModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addPriceForm="ngForm">
      <p>{{'doctrine.product.price.country'| translate}}</p>
      <hr>
      <div class="form-row row">
        <div class="form-group col-md-6">
          <label for="country">{{'doctrine.product.price.country' | translate}} <span class="star">*</span></label>
          <ng-select [(ngModel)]="price.country" id="country" name="countryItem"
                     #countryItem="ngModel" [searchable]="false" [clearable]="false" required>
            <ng-option *ngFor="let country of countries" [value]="country.id">{{country.name}} </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="form-row row">
        <div class="form-group col-md-6">
        </div>
        <div class="form-group col-md-6">
        </div>
      </div>
      <p>{{'doctrine.product.price.price'| translate}}</p>
      <hr>
      <div class="form-row row">
        <div class="form-group col-md-6">
          <label class="float-label">{{'doctrine.product.price.dealer_price'|translate}} <span
            class="star">*</span></label>
          <div class="input-group">
            <span class="input-group-prepend">
              <span class="input-group-text">€</span>
            </span>
            <input type="text" name="dealerItem" #dealerItem="ngModel" [(ngModel)]="price.dealerPrice"
                   pattern="\d+([.]\d+)?"
                   class="form-control" required>
            <div class="messages text-danger"
                 *ngIf="dealerItem.invalid && dealerItem.dirty && dealerItem.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="dealerItem.invalid && dealerItem.dirty && dealerItem.errors?.pattern">
              {{'errors.invalid'|translate}}
            </div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="float-label">{{'doctrine.product.price.customer_price'|translate}} <span
            class="star">*</span></label>
          <div class="input-group">
             <span class="input-group-prepend">
              <span class="input-group-text">€</span>
            </span>

            <input type="text" name="customerItem" #customerItem="ngModel" [(ngModel)]="price.customerPrice"
                   pattern="\d+([.]\d+)?"
                   class="form-control" required>
            <div class="messages text-danger"
                 *ngIf="customerItem.invalid && customerItem.dirty && customerItem.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="customerItem.invalid && customerItem.dirty && customerItem.errors?.pattern">
              {{'errors.invalid'|translate}}
            </div>
          </div>
        </div>
      </div>
      <p>{{'doctrine.product.price.price'| translate}}</p>
      <hr>
      <div class="form-row row">
        <div class="col-md-6 form-group">
          <label class="float-label">{{'doctrine.product.price.discount'|translate}}</label>
          <div class="input-group">
            <span class="input-group-prepend">
              <span class="input-group-text">%</span>
            </span>
            <input type="text" name="discountItem" #discountItem="ngModel" [(ngModel)]="price.discount"
                   pattern="\d+([.]\d+)?"
                   class="form-control">
          </div>
          <div class="messages text-danger"
               *ngIf="discountItem.invalid && discountItem.dirty && discountItem.errors?.pattern">
            {{'errors.invalid'|translate}}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <!--  <button type="button" class="btn btn-simple ripple me-4"
              (click)="addPriceModal.hide();addPriceForm.reset()">eee{{'global.cancel'|translate}}</button>-->
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="cancelEdit()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="managePrice()" [disabled]="!addPriceForm.valid">
      {{(isEdit ? 'global.save_changes' : 'global.add') | translate}}

    </button>
  </div>
</app-modal-basic>

<!--add product Modal-->

<app-modal-basic #productsModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.modal_title'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelProductModel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <app-grid [grid]="productsGrid" *ngIf="showModal" (selectedRows)="addProduct($event)"
              [removeSelected]="removeSelected"></app-grid>
  </div>
  <!--modal button-->
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-2"
            (click)="cancelProductModel()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="addToProduct()">{{'global.add'|translate}}</button>
  </div>
</app-modal-basic>

<!--delete modal-->
<app-modal-basic #deleteModal>

  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Product'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}:
      <strong>{{(packageItemName) ? packageItemName : 'admin.product.show.add.set_name_default'|translate}}</strong> ?
    </p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="removePackage(DeleteModalIndex)">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>


<!--add part Modal-->
<app-modal-basic #partsModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.modal.add_part'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelPartModel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <app-grid [grid]="partsGrid" *ngIf="showPartModal" (selectedRows)="addPart($event)"
              [removeSelected]="removeSelectedPart"></app-grid>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-2"
            (click)="cancelPartModel()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="addToPart()">{{'global.add'|translate}}</button>
  </div>
</app-modal-basic>